<div class="login-body" style="background-image: url(./assets/img/bg/bg_login.jpg?v=20191102B) !important;">
<div class="row">
  <div class="col s12">
    <div class="container">
      <div id="login-page" class="row">
        <div class="col s12 m6 l4 z-depth-4 card-panel border-radius-6 login-card bg-opacity-8">
          <form class="login-form">
            <div class="row">
              <div class="input-field col s12">
                <h5 class="ml-4">Sign in</h5>
              </div>
            </div>
            <div class="row margin">
              <div class="input-field col s12">
                <i class="material-icons prefix pt-2">person_outline</i>
                <input [(ngModel)]="pageData.email" id="txtEmail" name="txtEmail" type="email">
                <label for="txtEmail" class="center-align">Email</label>
              </div>
            </div>
            <div class="row margin">
              <div class="input-field col s12">
                <i class="material-icons prefix pt-2">lock_outline</i>
                <input [(ngModel)]="pageData.password" id="txtPassword" name="txtPassword" type="password">
                <label for="txtPassword">Password</label>
              </div>
            </div>
            <div class="row">
              <div class="col s12 m12 l12 ml-2 mt-1">
                <p>
                  <label>
                    <input type="checkbox">
                    <span>Remember Me</span>
                  </label>
                </p>
              </div>
            </div>
            <div class="row">
              <div class="input-field col s12">
                <!-- <button *ngIf="!pageData.isSubmitting" (click)="onSubmit()" class="btn waves-effect waves-light border-round gradient-45deg-purple-deep-purple col s12" type="submit">Login</button> -->
                <button *ngIf="!pageData.isSubmitting" (click)="onSubmit()" class="btn waves-effect waves-light border-round gradient-45deg-amber-amber col s12" type="submit">Login</button>
                
                <!-- <a *ngIf="!pageData.isSubmitting" (click)="onSubmit()" href="javascript:void(0);" class="">Login</a> -->
                <div style="margin-left:15px;">
                  <div *ngIf="pageData.isSubmitting" class="preloader-wrapper small active">
                    <div class="spinner-layer spinner-blue-only">
                      <div class="circle-clipper left">
                        <div class="circle"></div>
                      </div><div class="gap-patch">
                        <div class="circle"></div>
                      </div><div class="circle-clipper right">
                        <div class="circle"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="input-field col s6 m6 l6">
                <p class="margin medium-small hide"><a>Register Now!</a></p>
              </div>
              <div class="input-field col s6 m6 l6">
                <p class="margin right-align medium-small"><a (click)="forgotPasswordClick()" href="javascript:void(0);">Forgot password ?</a></p>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
</div>